import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestChecklistPut = {
    path: "/checklist/:id",
    method: RouteHttpVerb.PUT
};
